import { FC, ReactElement } from 'react'

import { ConnectedShiftExchangeDetail } from '@/connectors'

export const ShiftExchangeDetailPage: FC = (): ReactElement => <ConnectedShiftExchangeDetail />
